import styled from 'styled-components';
import { getNotificationList } from '@/api/cs';
import { useQuery, useQueryClient } from 'react-query';
import { useState } from 'react';
import { Notification } from '@/types/cs.type';
import CsResultItem from '@/components/sideNavigation/Cs/result/CsResultItem';
import AlertBottomSheet from '@/components/sideNavigation/Cs/common/AlertBottomSheet';

function CsResult() {
  const queryClient = useQueryClient();
  const [resultList, setResultList] = useState<Notification[]>([]);
  const [openedBottomSheet, setOpenedBottomSheet] = useState<number | null>(
    null,
  );

  const { data } = useQuery(['ResultList'], getNotificationList, {
    onSuccess: (data) => {
      const newResultList = data.events.filter(
        (notification) =>
          notification.message.notificationType === 'REQUIREMENT_RESULT',
      );
      setResultList(newResultList);
    },
  });

  if (resultList.length === 0) {
    return (
      <NoResultWrapper>
        <NoResult>내역이 없습니다</NoResult>
      </NoResultWrapper>
    );
  }

  return (
    <>
      <ResultList>
        {resultList.map((result) => (
          <CsResultItem
            result={result}
            onOpenBottomSheet={setOpenedBottomSheet}
          />
        ))}
      </ResultList>
      <AlertBottomSheet
        openedBottomSheet={openedBottomSheet}
        onClose={() => {
          queryClient.invalidateQueries('ResultList');
          queryClient.invalidateQueries('messageAlertList');
          setOpenedBottomSheet(null);
        }}
      />
    </>
  );
}

const ResultList = styled.div`
  width: 100%;
  overflow-y: auto;
`;

const NoResultWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  padding: 0 29px;
`;

const NoResult = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6165;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
`;

export default CsResult;
